export {
    default,
    type SubCategoriesCardTemplateProps,
    type SubCategoryCardTemplateType,
} from './SubCategoriesCardTemplate';
